import React, { useEffect } from 'react'
import styles from './home.module.scss'
import { Header } from '../../organisms/Header/Header'
import teethImage from '../../../assets/images/first-image.png'
import rrethNeshImage from '../../../assets/images/rrethnesh.png'
import pulmoImage from '../../../assets/images/pulmo-compressed.jpg'
import stomaImage from '../../../assets/images/stoma-compressed.jpg'
import interImage from '../../../assets/images/inter-compressed.jpg'
import lungIcon from '../../../assets/images/lung.png'
import heartIcon from '../../../assets/images/heart.png'
import teethIcon from '../../../assets/images/teeth.png'
import emp1Image from '../../../assets/images/emp1-compressed-v2.jpg'
import emp2Image from '../../../assets/images/emp2-compressed-v3.jpg'
import emp3Image from '../../../assets/images/emp3-compressed-v2.jpg'
import emp4Image from '../../../assets/images/emp4-compressed-v3.jpg'
import emp5Image from '../../../assets/images/emp5-compressed-v3.jpg'
import { CategoryCard } from '../../organisms/CategoryCard/CategoryCard'

import { ReactComponent as Logo } from '../../../assets/images/logo.svg'
import { Button } from '../../atoms/Button/Button'

export const Home = () => {
  // Add useEffect to scroll to top on component mount (page refresh)
  useEffect(() => {
    // Disable browser's scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
    
    // Force scroll to top on page refresh or initial load
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Use instant for immediate scroll without animation
      })
    }
    
    // Execute immediately
    scrollToTop()
    
    // Also execute after a small delay to ensure DOM is fully loaded
    const timeoutId = setTimeout(scrollToTop, 100)
    
    // Additional execution after images and content are loaded
    const loadTimeoutId = setTimeout(scrollToTop, 500)
    
    // Cleanup timeouts on unmount
    return () => {
      clearTimeout(timeoutId)
      clearTimeout(loadTimeoutId)
    }
  }, [])

  const categoryCardsData = [
    {
      image: pulmoImage,
      logo: lungIcon,
      title: 'Pulmonology',
      text: 'Kujdes specializuar për sëmundjet e frymëmarrjes dhe të mushkërive me Dr. Vera Lleshi. Konsultime, diagnostikë dhe ndjekje e plotë.'
    },
    {
      image: interImage,
      logo: heartIcon,
      title: 'Internist',
      text: 'Shërbime mjekësie të brendshme për shëndetin e përgjithshëm. Vlerësim, diagnostikë dhe këshilla për një jetë më të shëndetshme.'
    },
    {
      image: stomaImage,
      logo: teethIcon,
      title: 'Stomatology',
      text: 'Shërbime dentare të plota: parandalim, pastrim, mbushje, ekstraksion dhe estetikë dentare për buzëqeshje të shëndetshme.'
    }
  ]

  const teamMembers = [
    { name: 'Dr.Spec. Vera Lleshi', title: 'PULMONOLOGE', image: emp1Image },
    { name: 'Dr.Engjëll Lleshi', title: 'DENTIST', image: emp2Image },
    { name: 'Dr.Diellor Lleshi', title: 'DENTIST', image: emp5Image },
    { name: 'Dr.Rinor Lleshi', title: 'DENTIST', image: emp3Image },
    { name: 'Rdh.Leona Gjoni-Lleshi', title: 'HIGJIENISTE DENTARE', image: emp4Image }
  ]

  const scrollToFooter = () => {
    const footer = document.getElementById('footer')
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className={styles.home}>
      <Header />
      <div id="firstSection" className={styles.firstSection}>
        <div className={styles.rightText}>
          <h1>
            Buzëqeshja është <br />
            <span>Gjuha</span> Universale
          </h1>
          <p>
            Shërbime Dentare Elite për <br /> Buzëqeshje të Paharrueshme!
          </p>
        </div>
        <div className={styles.heroImage}>
          <img alt='teeth-closeup' src={teethImage} loading="lazy" />
        </div>
      </div>
      
      <div id="secondSection" className={styles.secondSection}>
        <div className={styles.toothFrame}>
          <img alt='rreth-nesh' src={rrethNeshImage} loading="lazy" />
        </div>
        <div className={styles.secondText}>
          <h4>Rreth nesh</h4>
          <p>
            Dental Med DIP SH.P.K. është një qendër shëndetësore në Gjakovë që ofron shërbime dentare, pulmonologjike dhe të mjekësisë së brendshme. Me një ekip specializues dhe pajisje moderne, synojmë kujdes të cilësisë dhe buzëqeshje të shëndetshme për secilin pacient.
          </p>
        </div>
      </div>
      
      <div id="thirdSection" className={styles.thirdSection}>
        <div className={styles.thirdText}>
          <h4>
            Shërbime cilësore <br /> për kujdesin oral
          </h4>
          <div className={styles.rightContent}>
            <p>Zgjidhni shërbimin që ju nevojitet: stomatologji, pulmonologji ose mjekësi e brendshme. Na kontaktoni për termina dhe këshilla.</p>
            <Button text='Na kontaktoni →' onClick={scrollToFooter} />
          </div>
        </div>
        <div className={styles.categoryCards}>
          {categoryCardsData.map((cardData, index) => (
            <CategoryCard
              key={index}
              image={cardData.image}
              logo={cardData.logo}
              title={cardData.title}
              text={cardData.text}
              index={index}
            />
          ))}
        </div>
      </div>

      <div id="teamSection" className={styles.teamSection}>
        <div className={styles.teamContent}>
          <h4>Ekipa Jonë</h4>
          <p>Profesionistë me përvojë, të dedikuar për shëndetin dhe buzëqeshjen tuaj.</p>
          <div className={styles.teamGrid}>
            {teamMembers.map((member, index) => (
              <div key={index} className={styles.teamCard}>
                <div className={styles.teamCardImage}>
                  <img src={member.image} alt={member.name} loading="lazy" />
                </div>
                <div className={styles.teamCardInfo}>
                  <h5>{member.name}</h5>
                  <p>{member.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div id="footer" className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.footerHeader}>
            <div className={styles.logoContainer}>
              <Logo />
            </div>
            <div className={styles.brandName}>
              <span>Dental Med</span>
            </div>
          </div>
          
          <div className={styles.horizontalLine}></div>
          
          <div className={styles.contactInfo}>
            <div className={styles.contactColumn}>
              <div className={styles.verticalLine}></div>
              <div className={styles.contactItem}>
                <div className={styles.contactIcon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="white"/>
                  </svg>
                </div>
                <div className={styles.contactText}>
                  <div>Deshmoret e Lirise</div>
                  <div>Gjakove</div>
                </div>
              </div>
            </div>
            
            <div className={styles.contactColumn}>
              <div className={styles.verticalLine}></div>
              <div className={styles.contactItem}>
                <div className={styles.contactIcon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="white"/>
                  </svg>
                </div>
                <div className={styles.contactText}>
                  <div>+38349906111</div>
                </div>
              </div>
            </div>
            
            <div className={styles.contactColumn}>
              <div className={styles.verticalLine}></div>
              <div className={styles.contactItem}>
                <div className={styles.contactIcon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="white"/>
                  </svg>
                </div>
                <div className={styles.contactText}>
                  <div>@dentalmedks</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className={styles.blueBackground}>
        <div className={styles.repeatingText}>
          <span>Dental Med</span>
          <span>Pulmonologji</span>
          <span>Stomatologji</span>
          <span>Mjekesi e Brendshme</span>
          <span>Higjiene Dentare</span>
          <span>Implantologji</span>
          <span>Radiografi</span>
          <span>Kujdes Parandalues</span>
          <span>Urgjenca Dentare</span>
          <span>Kontrolla Periodike</span>
        </div>
      </div>
    </div>
  )
}
